module.exports = __webpack_public_path__ + "static/media/template.237d42b8.svg";